import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from 'react';
import { Star } from '../svgs/Star';

var RatingContainer = _styled("div", {
  target: "ee6jh4d0",
  label: "RatingContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "149agr5",
  styles: "display:flex;flex-direction:row;justify-content:space-between;width:auto;"
} : {
  name: "149agr5",
  styles: "display:flex;flex-direction:row;justify-content:space-between;width:auto;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9TdGFyUmF0aW5nL2luZGV4LmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNa0MiLCJmaWxlIjoiLi4vLi4vc3JjL1N0YXJSYXRpbmcvaW5kZXguanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBudW1iZXIgfSBmcm9tICdwcm9wLXR5cGVzJ1xuXG5pbXBvcnQgeyBTdGFyIH0gZnJvbSAnLi4vc3Zncy9TdGFyJ1xuXG5jb25zdCBSYXRpbmdDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuXHRkaXNwbGF5OiBmbGV4O1xuXHRmbGV4LWRpcmVjdGlvbjogcm93O1xuXHRqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG5cdHdpZHRoOiBhdXRvO1xuYFxuU3RhclJhdGluZy5wcm9wVHlwZXMgPSB7XG5cdHJhdGluZzogbnVtYmVyLmlzUmVxdWlyZWQsXG5cdHRvdGFsTnVtT2ZTdGFyczogbnVtYmVyLFxufVxuLyoqXG4gKiBTdGFyIFJhdGluZyBDb21wb25lbnQsIGRpc3BsYXlzIGZpbGxlZCBpbiBzdGFycyBiYXNlZCBvbiByYXRpbmcgc3lzdGVtXG4gKiBDYW4gY3VycmVudGx5IHN1cHBvcnQgaGFsZiBhbmQgd2hvbGUgcmF0aW5nc1xuICpcbiAqIEBwYXJhbSB7TnVtYmVyfSBwcm9wcy5yYXRpbmcgOjogYXZlcmFnZSByYXRpbmcgdGhhdCBzaG91bGQgYmUgZGlzcGxheWVkXG4gKiBAcGFyYW0ge051bWJlcn0gcHJvcHMudG90YWxOdW1PZlN0YXJzIDo6IG51bWJlciBvZiBzdGFycyB0aGF0IHRoZSByYXRpbmcgaXMgb3V0IG9mXG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBTdGFyUmF0aW5nKHsgcmF0aW5nLCB0b3RhbE51bU9mU3RhcnMgPSA1IH0pIHtcblx0cmV0dXJuIChcblx0XHQ8UmF0aW5nQ29udGFpbmVyPlxuXHRcdFx0e1suLi5BcnJheSh0b3RhbE51bU9mU3RhcnMpXS5tYXAoKHN0YXIsIGkpID0+IHtcblx0XHRcdFx0Y29uc3QgY3VycmVudFN0YXIgPSBpICsgMVxuXHRcdFx0XHRpZiAoTWF0aC5mbG9vcihyYXRpbmcpID49IGkgKyAxKSB7XG5cdFx0XHRcdFx0cmV0dXJuIDxTdGFyIGtleT17aX0gdmFyaWFudD1cImZ1bGxcIiAvPlxuXHRcdFx0XHR9IGVsc2UgaWYgKGN1cnJlbnRTdGFyID4gcmF0aW5nICYmIGN1cnJlbnRTdGFyIC0gMSA8IHJhdGluZykge1xuXHRcdFx0XHRcdHJldHVybiA8U3RhciBrZXk9e2l9IHZhcmlhbnQ9XCJoYWxmXCIgLz5cblx0XHRcdFx0fSBlbHNlIHtcblx0XHRcdFx0XHRyZXR1cm4gPFN0YXIga2V5PXtpfSAvPlxuXHRcdFx0XHR9XG5cdFx0XHR9KX1cblx0XHQ8L1JhdGluZ0NvbnRhaW5lcj5cblx0KVxufVxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

/**
 * Star Rating Component, displays filled in stars based on rating system
 * Can currently support half and whole ratings
 *
 * @param {Number} props.rating :: average rating that should be displayed
 * @param {Number} props.totalNumOfStars :: number of stars that the rating is out of
 */
export function StarRating(_ref) {
  var rating = _ref.rating,
      _ref$totalNumOfStars = _ref.totalNumOfStars,
      totalNumOfStars = _ref$totalNumOfStars === void 0 ? 5 : _ref$totalNumOfStars;
  return /*#__PURE__*/React.createElement(RatingContainer, null, _toConsumableArray(Array(totalNumOfStars)).map(function (star, i) {
    var currentStar = i + 1;

    if (Math.floor(rating) >= i + 1) {
      return /*#__PURE__*/React.createElement(Star, {
        key: i,
        variant: "full"
      });
    } else if (currentStar > rating && currentStar - 1 < rating) {
      return /*#__PURE__*/React.createElement(Star, {
        key: i,
        variant: "half"
      });
    } else {
      return /*#__PURE__*/React.createElement(Star, {
        key: i
      });
    }
  }));
}